import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Lock } from 'lucide-react';
export function FinalPricingCTA() {
  return <section className="py-12 md:py-16 bg-gold/5 text-navy text-center" data-id="element-98">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-99">
        <div className="text-4xl mb-4" data-id="element-100">🎓</div>
        <h2 className="text-2xl md:text-3xl font-bold font-heading mb-2" data-id="element-101">
          "Desde hoy, la hora de leer en tu casa tiene sistema."
        </h2>
        <p className="text-gold-600 font-bold text-sm uppercase tracking-wider mb-8" data-id="element-102">
          Última oportunidad — elegí tu plan
        </p>

        <div className="flex justify-center gap-4 text-xs text-slate-500 mb-10" data-id="element-103">
          <span className="flex items-center" data-id="element-104">
            <ShieldCheck className="w-3 h-3 mr-1" data-id="element-105" /> Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-106">
            <Zap className="w-3 h-3 mr-1" data-id="element-107" /> Acceso inmediato
          </span>
          <span className="flex items-center" data-id="element-108">
            <Lock className="w-3 h-3 mr-1" data-id="element-109" /> Pago seguro
          </span>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 text-left max-w-2xl mx-auto" data-id="element-110">
          {/* Base */}
          <div className="bg-white border border-slate-200 shadow-sm rounded-xl p-6" data-id="element-111">
            <h3 className="font-bold text-blue-600 mb-1" data-id="element-112">
              📘 Mis Primeras Lecturas (plan base)
            </h3>
            <p className="text-xs text-slate-500 mb-4" data-id="element-113">5 Tomos + 3 Bonos</p>
            <div className="flex items-baseline gap-2 mb-4" data-id="element-114">
              <span className="text-slate-400 line-through text-sm" data-id="element-115">
                $39.990
              </span>
              <span className="text-2xl font-bold text-navy" data-id="element-116">$17.990</span>
            </div>
            <Button variant="primary" className="w-full bg-blue-600 hover:bg-blue-700" href="https://www.tupuntodigital.shop/cart/46116455907501:1" data-id="element-117">
              QUIERO EL PLAN BASE
            </Button>
          </div>

          {/* Premium */}
          <div className="bg-white border border-gold/40 shadow-md rounded-xl p-6 relative" data-id="element-118">
            <div className="absolute -top-3 left-4 bg-gold text-navy text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-119">
              ⭐ El más elegido
            </div>
            <h3 className="font-bold text-gold-600 mb-1 mt-1" data-id="element-120">
              🏆 Mis Primeras Lecturas + Kit Acelerador
            </h3>
            <p className="text-xs text-slate-600 mb-4" data-id="element-121">
              Para padres que quieren todas las herramientas listas
            </p>
            <div className="flex items-baseline gap-2 mb-4" data-id="element-122">
              <span className="text-slate-400 line-through text-sm" data-id="element-123">
                $59.990 ARS
              </span>
              <span className="text-2xl font-bold text-navy" data-id="element-124">$24.990 ARS</span>
            </div>
            <Button variant="gold" className="w-full" href="https://www.tupuntodigital.shop/cart/46116456104109:1" data-id="element-125">
              QUIERO EL PREMIUM
            </Button>
          </div>
        </div>

        <div className="mt-8 text-xs text-slate-500" data-id="element-126">
          Mercado Pago | Tarjeta | Transferencia
        </div>
      </div>
    </section>;
}